export enum WoundStatusEnum {
  Drafted = 1,
  RequiresClinicalVerification = 2,
  InProgress = 3,
  Healed = 4
}

export const WoundStatusOptions = [
{ id: 1, label: 'Drafted' },
{ id: 2, label: 'Requires Clinical Verification' },
{ id: 3, label: 'In Progress' },
{ id: 4, label: 'Healed' }
];
